import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      redirected: false,
      isChunkError: false
    };
  }

  static getDerivedStateFromError(error) {
    console.log('ErrorBoundary caught an error:', error);
    return {
      hasError: true,
      isChunkError: error.message?.includes('Loading chunk')
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error logged:', error, errorInfo);

    this.setState(
      {
        error: error,
        errorInfo: errorInfo,
        isChunkError: error.message?.includes('Loading chunk')
      },
      () => {
        // Only redirect to error500 if it's not a chunk error
        if (!this.state.isChunkError && !this.state.redirected) {
          this.handleRedirect();
        }
      }
    );
  }

  handleRedirect = () => {
    this.setState({ redirected: true });
    console.log('Error info at redirect:', this.state.errorInfo);

    this.props.history.push('/error-500', {
      error: {
        message: this.state.error?.message || 'Unknown error',
        stack: this.state.error?.stack || 'No stack trace available',
        componentStack: this.state.errorInfo?.componentStack || 'No component stack available',
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    // Reset error state when navigating away from error
    if (prevProps.location.pathname !== this.props.location.pathname && this.state.hasError) {
      this.setState({
        hasError: false,
        error: null,
        errorInfo: null,
        redirected: false,
        isChunkError: false
      });
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.state.isChunkError) {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '100vh',
              padding: '20px',
              backgroundColor: '#f8f9fa'
            }}
          >
            <div className="text-center mb-4">
              <div className="mb-3">
                <em className="fa fa-sync fa-5x text-muted"></em>
              </div>
              <div className="text-lg mb-3">
                <FormattedMessage
                  id="ErrorBoundary.title_updateAvailable"
                  defaultMessage="Update Available"
                />{' '}
              </div>
              <div className="mb-2">
                <p className="lead m-0">
                  <FormattedMessage
                    id="ErrorBoundary.msg_updateAvailable"
                    defaultMessage="A new version of the application is available"
                  />
                </p>
              </div>
              <div
                style={{
                  maxWidth: '600px',
                  width: '100%',
                  marginBottom: '20px',
                  textAlign: 'center'
                }}
              >
                <div
                  style={{
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '5px',
                    marginBottom: '15px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                >
                  <p style={{ marginBottom: '15px' }}>
                    <FormattedMessage
                      id="ErrorBoundary.msg_reloadPage"
                      defaultMessage="Please reload the page to get the latest version."
                    />
                  </p>
                </div>
              </div>
            </div>
            <div className="p-3 text-center">
              <span className="mr-2">&copy;</span>
              <span>2025</span>
              <span className="mx-2">-</span>
              <span>Recrut.AI</span>
            </div>
          </div>
        );
      }
      // Return null or a minimal loading state while redirecting for non-chunk errors
      return null;
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
